<!-- Loading state -->
<div *ngIf="isLoading" style="padding: 40px; text-align: center; color: #6b7280;">
    Loading trip details...
  </div>
  
  <div class="main-wrapper" *ngIf="!isLoading && order">
    <div class="page-wrapper">
      <div class="content">
        <div class="trip-view-content">
  
          <!-- Title Row -->
          <div class="order-title-row">
            <div>
              <h4 class="order-title">{{ order.orderNo }} &mdash; {{ order.customerName }}</h4>
              <div class="order-subtitle">
                {{ order.route }}
                <span class="dot">&middot;</span>
                <span class="badge order-type-badge" [ngClass]="order.orderType?.toLowerCase()">
                  {{ order.orderType | titlecase }}
                </span>
              </div>
            </div>
            <div class="title-actions">
              <span class="badge status-badge" [ngClass]="statusBadgeClass()">{{ statusLabel() }}</span>
              <a href="javascript:void(0)" class="back-link" (click)="goBack()">Back</a>
            </div>
          </div>
  
           <!-- ══════════════════════════════════════
               Order Status Timeline
          ══════════════════════════════════════ -->
          <div class="card-section" *ngIf="order.orderStatus && order.orderStatus.length">
            <div class="section-header">
              <!-- <span class="step-badge">7</span> -->
              <h5>Order Status</h5>
            </div>
            <div class="section-body">
              <div class="status-timeline">
                <div class="status-item" *ngFor="let s of order.orderStatus">
                  <div class="status-dot" [ngClass]="statusDotClass(s.status)"></div>
                  <div class="status-info">
                    <span class="status-type">  {{ formatStatusType(s.statusType) }}</span>
                    <span class="badge status-pill" style="font-size: 9px;" [ngClass]="statusPillClass(s.status)">
                      {{ humanize(s.status) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
  

          <!-- ══════════════════════════════════════
               SECTION 1: General Details (Read Only)
          ══════════════════════════════════════ -->
          <div class="card-section">
            <div class="section-header">
              <span class="step-badge">1</span>
              <h5>General Details</h5>
              <span class="read-only-badge">🔒 Read only</span>
            </div>
            <div class="section-body">
              <div class="form-grid">
  
                <div class="form-field">
                  <label>Order No.</label>
                  <input type="text" class="form-control" [value]="order.orderNo" readonly />
                </div>
  
                <div class="form-field">
                  <label>Trip Number</label>
                  <input type="text" class="form-control highlight-purple"
                    [value]="tripData?.tripNumber || 'Auto-generated on Start Trip'" readonly />
                </div>
  
                <div class="form-field">
                  <label>From</label>
                  <input type="text" class="form-control" [value]="order.source || '--'" readonly />
                </div>
  
                <div class="form-field">
                  <label>To</label>
                  <input type="text" class="form-control" [value]="order.destination || '--'" readonly />
                </div>
  
                <div class="form-field">
                  <label>Vehicle Type</label>
                  <ng-select
                    [items]="vehicleTypeList"
                    bindLabel="vehicleType"
                    [readonly]="true"
                    class="padding-8px"
                    bindValue="id"
                    appendTo="body"
                    [(ngModel)]="order.vehicleTypeId">
                    </ng-select>
                </div>
  
                <div class="form-field">
                  <label>No. of Trucks</label>
                  <input type="text" class="form-control" [value]="order.numberOfVehicle" readonly />
                </div>
  
                <div class="form-field">
                  <label>Placement Date</label>
                  <input type="text" class="form-control" [value]="order.vehicleRequiredAt || '--'" readonly />
                </div>

                <div class="form-field">
                  <label>Assigned KAM</label>
                  <ng-select
                    class="padding-8px disabled"
                    [items]="kamList"
                    bindLabel="name"
                    [readonly]="true"
                    bindValue="id"
                    appendTo="body"
                    [disabled]="true"
                    placeholder="Select KAM"
                    [(ngModel)]="order.assignedKam">
                  </ng-select>
                </div>
  
                <div class="form-field">
                  <label>Assigned Procurement Exec.</label>
                  <ng-select
                    class="padding-8px disabled"
                    [items]="procurementExecList"
                    bindLabel="name"
                    [readonly]="true"
                    bindValue="id"
                    appendTo="body"
                    [disabled]="true"
                    [(ngModel)]="order.assignedProcExec"
                    placeholder="Select procurement executive">
                  </ng-select>
                </div>
  
                <div class="form-field">
                  <label>Trip Status</label>
                  <span class="badge status-pill" [ngClass]="statusPillClass(rawTripStatus())">
                    {{ tripStatusLabel() }}
                  </span>
                </div>

                <div class="form-field" *ngIf="tripData?.managementStatus">
                    <label>Management Status</label>
                    <span class="badge status-pill" [ngClass]="statusPillClass(tripData?.managementStatus)">
                      {{ tripData?.managementStatus }}
                    </span>
                </div>
                
  
                <div class="form-field" *ngIf="tripData?.vendorName">
                  <label>Vendor</label>
                  <input type="text" class="form-control highlight-green" [value]="tripData?.vendorName" readonly />
                </div>
  
              </div>
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 2: LHC Details — repeatable (ROLE_PROCUREMENT editable)
               Vehicle / driver / payment only — LR lives in its own section below.
               Payment Details sub-section is visible to ROLE_PROCUREMENT only.
          ══════════════════════════════════════ -->
          <div class="card-section">
            <div class="section-header between">
              <div class="d-flex justify-content-between align-items-center gap-2 w-100">
                <span class="d-flex align-items-center gap-2">
                  <span class="step-badge">2</span>
                  <h5>LHC Details</h5>
                </span>
                <span class="d-flex align-items-center justify-content-between gap-2">
                  <button class="btn badge-green" *ngIf="tripData?.managementStatus === 'PENDING' && hasRole('ROLE_MANAGEMENT')" (click)="acceptRejectManagement('APPROVED')">
                    Approve
                  </button>
                  <button class="btn badge-red" *ngIf="tripData?.managementStatus === 'PENDING' && hasRole('ROLE_MANAGEMENT')" (click)="acceptRejectManagement('REJECT')">
                    Reject
                  </button>
                  <span class="read-only-badge" *ngIf="!canEditLhc()">🔒 Read only</span>
                </span>
              </div>
            </div>
  
            <div class="section-body">
  
              <div class="info-banner" *ngIf="canEditLhc()">
                ℹ Fill in driver &amp; vehicle details below.
              </div>
  
              <div class="repeatable-block" *ngFor="let row of lhcRows; let i = index">
                <div class="repeatable-header" *ngIf="lhcRows.length > 1 || canEditLhc()">
                  <span class="repeatable-title">Vehicle</span>
                  <span
                      class="lhc-section-icon cursor-pointer"
                      *ngIf="canEditLhc() && lhcRows.length > 1"
                      (click)="removeLhcRow(i)">
                      ❌
                    </span>
                </div>
  
                <div class="form-grid">
  
                <div class="form-field" *ngIf="notRole('ROLE_KAM')">
                    <label>Vendor Name </label>
                    <input
                      type="text"
                      class="form-control"
                      [ngClass]="{ 'editable': canEditLhc() }"
                      [readonly]='true'
                      [(ngModel)]="row.vendorName"
                      placeholder="Vendor Name" />
                </div>

                <div class="form-field" *ngIf="notRole('ROLE_KAM')">
                    <label>Vendor Mobile </label>
                    <input
                      type="text"
                      class="form-control"
                      [ngClass]="{ 'editable': canEditLhc() }"
                      [readonly]="!canEditLhc()"
                      [(ngModel)]="row.vendorMobile"
                      placeholder="Vendor Mobile" />
                </div>

                  <div class="form-field">
                    <label>Vehicle Number </label>
                    <input
                      type="text"
                      class="form-control"
                      [ngClass]="{ 'editable': canEditLhc() }"
                      [readonly]="!canEditLhc()"
                      [(ngModel)]="row.vehicleNumber"
                      placeholder="Vehicle Number" />
                  </div>
  
                  <div class="form-field">
                    <label>Driver Name </label>
                    <input
                      type="text"
                      class="form-control"
                      [ngClass]="{ 'editable': canEditLhc() }"
                      [readonly]="!canEditLhc()"
                      [(ngModel)]="row.driverName"
                      placeholder="Full name" />
                  </div>
  
                  <div class="form-field">
                    <label>Driver Mobile </label>
                    <input
                      type="text"
                      class="form-control"
                      [ngClass]="{ 'editable': canEditLhc() }"
                      [readonly]="!canEditLhc()"
                      [(ngModel)]="row.driverMobile"
                      placeholder="10-digit mobile number"
                      maxlength="10" />
                  </div>
  
                  <div class="form-field">
                    <label>Driver License No. <span class="optional-label">(optional)</span></label>
                    <input
                      type="text"
                      class="form-control"
                      [ngClass]="{ 'editable': canEditLhc() }"
                      [readonly]="!canEditLhc()"
                      [(ngModel)]="row.licenseNumber"
                      placeholder="Driver License No." />
                  </div>
  
                </div>
  
                <!-- Payment Details — Tally Integration — ROLE_PROCUREMENT only -->
                <ng-container *ngIf="canEditLhc()">
                  <div class="sub-section-header">
                    <span>💰</span>
                    <span>Payment Details</span>
                  </div>
    
                  <div class="form-grid">
    
                    <div class="form-field">
                      <label>Total Freight (₹)</label>
                      <input type="text" class="form-control highlight-green"
                        [value]="formatCurrency(order.procurementProvidedAmount)" readonly />
                    </div>
    
                    <div class="form-field">
                      <label>Advance Amount (₹) <span class="required">*</span></label>
                      <input
                          type="text"
                          appIndianNumberFormat
                          class="form-control editable"
                          [(ngModel)]="row.advanceAmount"
                          (ngModelChange)="onAdvanceAmountInput($event, row)"
                          min="0"
                          [max]="order.procurementProvidedAmount ?? 0"
                          />
                    </div>
                    
                    <div class="form-field">
                      <label>Advance Percentage (%)</label>
                      <input
                        type="number"
                        class="form-control editable"
                        [(ngModel)]="row.advancePercentage"
                        (ngModelChange)="onAdvancePercentageChange(row)"
                        min="0"
                        max="100"
                        placeholder="Advance Percentage (%)" />
                    </div>
    
                    <div class="form-field">
                      <label>Balance Payable (₹)</label>
                      <input type="text" class="form-control"
                        [value]="formatCurrency(balancePayable(row))" readonly />
                    </div>
    
                  </div>
                </ng-container>
  
                <div class="row-footer" *ngIf="canEditLhc() && (tripData?.lhcStatus === 'PENDING' || !tripData?.lhcStatus)">
                  <button
                    type="button"
                    class="btn btn-purple"
                    [disabled]="row.saving || !isLhcRowValid(row)"
                    (click)="saveLhcRow(row)">
                    {{ row.saving ? 'Sending...' : (row.id ? 'Send for approval' : 'Send for approval') }}
                  </button>
                </div>
              </div>
  
            </div>
  
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 3: LR — Lorry Receipt — repeatable, single Save
               Independent of LHC vehicle count.
          ══════════════════════════════════════ -->
          <div class="card-section">
            <div class="section-header between">
              <div class="d-flex align-items-center gap-2">
                <span class="step-badge">3a</span>
                <h5>LR — Lorry Receipt</h5>
              </div>
              <span class="read-only-badge" *ngIf="!canEditLRInfo()">🔒 Read only</span>
              <button
                *ngIf="canEditLRInfo()"
                type="button"
                class="btn btn-add"
                (click)="addLrRow()">
                + Add LR
              </button>
            </div>
  
            <div class="section-body">
  
              <div class="repeatable-block" *ngFor="let lr of lrRows; let i = index">
                <div class="repeatable-header">
                  <span class="repeatable-title">
                    LR {{ i + 1 }}<span *ngIf="lr.lrNumber"> &middot; #{{ lr.lrNumber }}</span>
                  </span>
                  <span
                    class="lhc-section-icon cursor-pointer"
                    *ngIf="lrRows.length > 1"
                    (click)="removeLrRow(i)">
                    ❌
                  </span>
                </div>
  
                <div class="radio-group">
                  <label class="radio-label">Created</label>
                  <div class="radio-options">
                    <label class="radio-option">
                      <input
                        type="radio"
                        [name]="'lrType' + i"
                        [checked]="lr.isManual"
                        (change)="lr.isManual = true; onLrTypeChange(lr)" />
                      Manual Entry
                    </label>
                    <label class="radio-option">
                      <input
                        type="radio"
                        [name]="'lrType' + i"
                        [checked]="!lr.isManual"
                        (change)="lr.isManual = false; onLrTypeChange(lr)" />
                      Auto Generate
                    </label>
                  </div>
                </div>
  
                <div class="form-grid">
  
                    <div class="form-field">
                      <label>LR Number <span class="required">*</span></label>
                      <div class="lr-number-row">
                        <input
                          type="text"
                          [readonly]="!canEditLRInfo()"
                          class="form-control"
                          [ngClass]="{ 'editable': lr.isManual }"
                          [readonly]="!lr.isManual"
                          [(ngModel)]="lr.lrNumber"
                          placeholder="LR Number" />
                        <span
                          class="lr-refresh-icon"
                          *ngIf="!lr.isManual"
                          [class.spinning]="lr.lrNumberGenerating"
                          (click)="!lr.lrNumberGenerating && fetchGeneratedLrNumber(lr)"
                          title="Regenerate LR Number">
                          ↻
                        </span>
                      </div>
                    </div>
  
                  <div class="form-field">
                    <label>LR Date <span class="required">*</span></label>
                    <input
                    [readonly]="!canEditLRInfo()"
                      type="datetime-local"
                      class="form-control editable"
                      [(ngModel)]="lr.lrDate" />
                  </div>
                  <div class="form-field ">
                    <label>Remarks <span class="optional-label">(optional)</span></label>
                    <textarea
                      class="form-control editable"
                      rows="2"
                      [readonly]="!canEditLRInfo()"
                      [(ngModel)]="lr.remarks"
                      placeholder="Any additional notes"></textarea>
                  </div>
                  <div class="form-field" *ngIf="lr.isManual">
                    <label>LR Document <span class="optional-label">(PDF or image)</span></label>
                    <div class="file-upload-row">
                      <label class="file-upload-btn">
                        📎 Choose File
                        <input type="file" hidden accept=".pdf,image/*" [readonly]="!canEditLRInfo()" (change)="onLrFileSelected($event, lr)" />
                      </label>
                      <span class="file-upload-status" *ngIf="lr.uploading">Uploading...</span>
                      <span class="file-upload-status success" *ngIf="!lr.uploading && lr.lrDocument">
                        ✓ Uploaded
                        <a
                          [href]="lr.lrDocument"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="document-link"
                          title="View Document">
                          <i class="pi pi-link"></i>
                        </a>
                      </span>
                      <span class="file-upload-status" *ngIf="!lr.uploading && !lr.lrDocument">No file chosen</span>
                    </div>
                  </div>
                </div>
  
              </div>
  
            </div>
  
            <div class="section-footer">
                <button type="button" class="btn btn-outline-purple" *ngIf="canPrintLrTemplate()" (click)="downloadLrTemplate()">⬇️ Download LR Template</button>
                <button *ngIf="canEditLRInfo()"
                    type="button"
                    class="btn btn-purple"
                    [disabled]="lrSaving || !hasNewLrRows()"
                    (click)="saveAllLr()">
                    {{ lrSaving ? 'Saving...' : 'Save' }}
                </button>
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 4: Loading Info (ROLE_OPERATION editable)
          ══════════════════════════════════════ -->
          <div class="card-section">
            <div class="section-header">
              <span class="step-badge">3b</span>
              <h5>Loading Info</h5>
              <span class="read-only-badge" *ngIf="!canEditLoadingInfo()">🔒 Read only</span>
            </div>
            <div class="section-body">
              <div class="form-grid">
  
                <div class="form-field">
                  <label>Reporting Date &amp; Time</label>
                  <input
                    type="datetime-local"
                    class="form-control"
                    [ngClass]="{ 'editable': canEditLoadingInfo() }"
                    [readonly]="!canEditLoadingInfo()"
                    [(ngModel)]="loadingForm.reportingDateTime" />
                </div>
  
                <div class="form-field">
                  <label>Loading Date &amp; Time</label>
                  <input
                    type="datetime-local"
                    class="form-control"
                    [ngClass]="{ 'editable': canEditLoadingInfo() }"
                    [readonly]="!canEditLoadingInfo()"
                    [(ngModel)]="loadingForm.loadingDateTime" />
                </div>
  
                <div class="form-field">
                  <label>Seal Number</label>
                  <input
                    type="text"
                    class="form-control"
                    [ngClass]="{ 'editable': canEditLoadingInfo() }"
                    [readonly]="!canEditLoadingInfo()"
                    [(ngModel)]="loadingForm.sealNumber"
                    placeholder="--" />
                </div>
  
                <div class="form-field">
                  <label>Material Description</label>
                  <input
                    type="text"
                    class="form-control"
                    [ngClass]="{ 'editable': canEditLoadingInfo() }"
                    [readonly]="!canEditLoadingInfo()"
                    [(ngModel)]="loadingForm.materialTypeDescription"
                    placeholder="--" />
                </div>
  
                <div class="form-field">
                  <label>Weight (Tons)</label>
                  <input
                    type="number"
                    class="form-control"
                    [ngClass]="{ 'editable': canEditLoadingInfo() }"
                    [readonly]="!canEditLoadingInfo()"
                    [(ngModel)]="loadingForm.weight"
                    placeholder="--" />
                </div>
  
                <div class="form-field">
                  <label>No. of Packages</label>
                  <input
                    type="number"
                    class="form-control"
                    [ngClass]="{ 'editable': canEditLoadingInfo() }"
                    [readonly]="!canEditLoadingInfo()"
                    [(ngModel)]="loadingForm.numberOfPackages"
                    placeholder="--" />
                </div>
  
              </div>
            </div>
  
            <div class="section-footer" *ngIf="canEditLoadingInfo()">
              <button
                type="button"
                class="btn btn-purple"
                [disabled]="loadingSaving || !hasLoadingInfoChanges()"
                (click)="saveLoadingInfo()">
                {{ loadingSaving ? 'Saving...' : 'Save' }}
              </button>
            </div>
          </div>
  
          <!-- ══════════════════════════════════════
               SECTION 5: E-Way Bill — repeatable, single Save
          ══════════════════════════════════════ -->
          <div class="card-section">
            <div class="section-header between">
              <div class="d-flex align-items-center gap-2">
                <span class="step-badge">3c</span>
                <h5>E-Way Bill</h5>
                <span class="read-only-badge" *ngIf="!canEditEwayBill()">🔒 Read only</span>
              </div>
              <div class="d-flex gap-2" *ngIf="canEditEwayBill()">
                <button type="button" class="btn btn-outline-purple" (click)="downloadEwayTemplate()">
                  ⬇️ Download Template
                </button>
                <button type="button" class="btn btn-outline-purple" (click)="openEwayBulkModal()">
                  📤 Bulk Upload
                </button>
                <button type="button" class="btn btn-add" (click)="addEwayRow()">
                  + Add E-Way Bill
                </button>
              </div>
            </div>
  
            <div class="section-body">
  
              <div class="repeatable-block position-relative" *ngFor="let bill of ewayRows; let i = index">
                <div class="repeatable-header">
                  <span class="repeatable-title">E-Way Bill {{ i + 1 }}</span>
                  <span
                      class="lhc-section-icon cursor-pointer"
                      *ngIf="canEditEwayBill() && ewayRows.length > 1"
                      (click)="removeEwayRow(i)">
                      ❌
                    </span>
                </div>
  
                <div class="form-grid">
  
                  <div class="form-field">
                    <label>GST Number <span class="required" *ngIf="canEditEwayBill()">*</span></label>
                    <select
                      class="form-control editable"
                      *ngIf="canEditEwayBill(); else gstReadonly"
                      [(ngModel)]="bill.gstNumber">
                      <option value="" disabled>Select GST number</option>
                      <option *ngFor="let g of gstList" [value]="gstValue(g)">{{ gstLabel(g) }}</option>
                    </select>
                    <ng-template #gstReadonly>
                      <input type="text" class="form-control highlight-green" [value]="bill.gstNumber" readonly />
                    </ng-template>
                  </div>
  
                  <div class="form-field">
                    <label>E-Way Bill Number <span class="required" *ngIf="canEditEwayBill()">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      [ngClass]="{ 'editable': canEditEwayBill() }"
                      [readonly]="!canEditEwayBill()"
                      [(ngModel)]="bill.ewayBillNumber"
                      placeholder="E-Way Bill No." />
                  </div>

                  <div class="form-field">
                    <label>Upload E-Way Bill <span class="optional-label">(PDF)</span></label>
                    <div class="file-upload-row">
                      <label class="file-upload-btn">
                        📎 Choose File
                        <input type="file" hidden accept=".pdf,image/*" (change)="onEwayFileSelected($event, bill)" />
                      </label>
                      <span class="file-upload-status" *ngIf="bill.uploading">Uploading...</span>
                      <span class="file-upload-status success" *ngIf="!bill.uploading && bill.docUrl">
                        ✓ Uploaded
                        <a
                          [href]="bill.docUrl"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="document-link"
                          title="View Document">
                          <i class="pi pi-link"></i>
                        </a>
                      </span>
                      <span class="file-upload-status" *ngIf="!bill.uploading && !bill.docUrl">No file chosen</span>
                    </div>
                  </div>
  
                </div>
  
                <div class="row-footer p-0" *ngIf="canEditEwayBill()">
                  <button
                    type="button" style="position: absolute;top: 15px;right: 40px;"
                    class="btn btn-fetch"
                    [disabled]="bill.fetching || !bill.gstNumber || !bill.ewayBillNumber"
                    (click)="fetchEwayBill(bill)">
                    {{ bill.fetching ? 'Getting Details...' : 'Get Details' }}
                  </button>
                </div>
  
                <div class="eway-fetched-card" *ngIf="bill.fetched">
                  <div class="eway-fetched-header">
                    <span>📋 E-Way Bill Details</span>
                    <span class="eway-fetched-badge">#{{ bill.ewayBillNumber }}</span>
                  </div>
                  <div class="eway-fetched-grid">
                    <div class="eway-fetched-field">
                      <label>Invoice No.</label>
                      <span>{{ bill.invoiceNo || '--' }}</span>
                    </div>
                    <div class="eway-fetched-field">
                      <label>Invoice Value (₹)</label>
                      <span class="value-green">{{ formatCurrency(bill.invoiceValue) }}</span>
                    </div>
                    <div class="eway-fetched-field">
                      <label>Invoice Date</label>
                      <span>{{ formatDisplayDate(bill.invoiceDateObj) }}</span>
                    </div>
                    <div class="eway-fetched-field">
                      <label>Vehicle No.</label>
                      <span>{{ bill.vehicleNo || '--' }}</span>
                    </div>
                    <div class="eway-fetched-field">
                      <label>LR Number</label>
                      <span>{{ bill.lrNumber || '--' }}</span>
                    </div>
                    <div class="eway-fetched-field">
                      <label>LR Date</label>
                      <span>{{ formatDisplayDate(bill.lrDateObj) }}</span>
                    </div>
                    <div class="eway-fetched-field">
                      <label>EWB Generated</label>
                      <span>{{ formatDisplayDate(bill.ewbDateObj) }}</span>
                    </div>
                    <div class="eway-fetched-field">
                      <label>Valid Upto</label>
                      <span class="valid-upto-badge">⏳ {{ formatDisplayDate(bill.validUptoObj) }}</span>
                    </div>
                  </div>
                </div>
                <div class="eway-error-card" *ngIf="!bill.fetched && bill.errorMessage">
                  <span>⚠️ {{ bill.errorMessage }}</span>
                  <span class="eway-fetched-badge">#{{ bill.ewayBillNumber }}</span>
                </div>
  
              </div>
  
            </div>
  
            <div class="section-footer" *ngIf="canEditEwayBill()">
              <button
                type="button"
                class="btn btn-purple"
                [disabled]="ewaySaving  || !hasNewEwayRows()"
                (click)="saveAllEway()">
                {{ ewaySaving ? 'Saving...' : 'Save' }}
              </button>
            </div>
          </div>

          <p-dialog
            header="Bulk Upload E-Way Bills"
            [(visible)]="showEwayBulkModal"
            [modal]="true"
            [closable]="!ewayBulkProcessing"
            [draggable]="false"
            [resizable]="false"
            [style]="{ width: '640px' }"
            styleClass="eway-bulk-dialog"
            (onHide)="onEwayBulkDialogHide()">

            <div class="info-banner">
              Download the template, fill in <b>GST Number</b> and <b>E-Way Bill Number</b> for each row, then upload it here.
              Rows already saved will be skipped automatically.
            </div>

            <div class="d-flex gap-2 mb-2 mt-2">
              <button type="button" class="btn btn-outline-purple" (click)="downloadEwayTemplate()">
                ⬇️ Download Template
              </button>
              <label class="file-upload-btn">
                📎 Upload Filled Template
                <input
                  type="file"
                  hidden
                  accept=".xlsx,.xls"
                  [disabled]="ewayBulkProcessing"
                  (change)="onEwayBulkFileSelected($event)" />
              </label>
            </div>

            <table class="bulk-eway-table" *ngIf="ewayBulkRows.length">
              <thead>
                <tr>
                  <th>GST Number</th>
                  <th>E-Way Bill Number</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of ewayBulkRows">
                  <td>{{ r.gstNumber }}</td>
                  <td>{{ r.ewayBillNumber }}</td>
                  <td>
                    <span *ngIf="r.status === 'pending'" class="status-pending">⏳ Pending</span>
                    <span *ngIf="r.status === 'fetching'" class="status-fetching">🔄 Fetching...</span>
                    <span *ngIf="r.status === 'success'" class="status-success">✓ Success</span>
                    <span *ngIf="r.status === 'skipped'" class="status-skipped">— {{ r.errorMessage }}</span>
                    <span *ngIf="r.status === 'error'" class="status-error" [title]="r.errorMessage">✖ {{ r.errorMessage }}</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <ng-template pTemplate="footer">
              <button
                type="button"
                class="btn btn-purple"
                [disabled]="ewayBulkProcessing"
                (click)="closeEwayBulkModal()">
                {{ ewayBulkProcessing ? 'Processing...' : 'Done' }}
              </button>
            </ng-template>

          </p-dialog>
          <!-- ══════════════════════════════════════
                SECTION 6: Pickup & Drop Locations (ROLE_OPERATION editable)
                Pickup + Drop are always added/removed together as a
                PAIR (1 LR maps to 1 pickup + 1 drop). A single
                "+ Add Location" button pushes one row into both
                pickupRows and dropRows.
            ══════════════════════════════════════ -->
            <div class="card-section">
                <div class="section-header between">
                <div class="d-flex align-items-center gap-2">
                    <span class="step-badge">3d</span>
                    <h5>Pickup &amp; Drop Locations</h5>
                    <span class="read-only-badge" *ngIf="!canEditLocations()">🔒 Read only</span>
                </div>
                <button
                    type="button"
                    class="btn btn-add"
                    *ngIf="canEditLocations()"
                    (click)="addLocationRow()">
                    + Add Location
                </button>
                </div>
            
                <div class="section-body d-flex gap-2">
                <div class="w-100">
                <!-- Pickup -->
                <div class="sub-section-header">
                    <span>📍</span>
                    <span>Pickup Locations</span>
                </div>
            
                <div class="repeatable-block" *ngFor="let pickup of pickupRows; let i = index">
                    <div class="repeatable-header" *ngIf="pickupRows.length > 1 || canEditLocations()">
                    <span class="repeatable-title">Pickup {{ i + 1 }}</span>
                    <span
                        class="lhc-section-icon cursor-pointer"
                        *ngIf="canEditLocations() && pickupRows.length > 1"
                        (click)="removeLocationRow(i)">
                        ❌
                    </span>
                    </div>
            
                    <div class="form-grid">
            
                    <div class="form-field">
                        <label>Pincode <span class="required" *ngIf="canEditLocations()">*</span></label>
                        <input
                        type="text"
                        class="form-control"
                        [ngClass]="{ 'editable': canEditLocations() }"
                        [readonly]="!canEditLocations()"
                        [(ngModel)]="pickup.pincode"
                        placeholder="Pincode" />
                    </div>
            
                    <div class="form-field">
                        <label>Location <span class="required" *ngIf="canEditLocations()">*</span></label>
                        <ng-select
                        [items]="locationList"
                        bindLabel="cityName"
                        bindValue="id"
                        appendTo="body"
                        [readonly]="!canEditLocations()"
                        placeholder="Select Location"
                        [(ngModel)]="pickup.city">
                        </ng-select>
                    </div>
            
                    <div class="form-field" *ngIf="pickup.city == -1">
                        <label>Custom Location Name <span class="required" *ngIf="canEditLocations()">*</span></label>
                        <input
                        type="text"
                        class="form-control"
                        [ngClass]="{ 'editable': canEditLocations() }"
                        [readonly]="!canEditLocations()"
                        [(ngModel)]="pickup.otherCity"
                        placeholder="Type Location" />
                    </div>

                    <!--
                      Select LR — links this Pickup to one of the LR
                      rows entered in the "LR — Lorry Receipt" section
                      above (1 LR per pickup+drop pair). UI only for
                      now; not yet sent in the save payload.
                    -->
                    <div class="form-field">
                        <label>Select LR</label>
                        <ng-select
                        [items]="lrRows"
                        bindLabel="lrNumber"
                        bindValue="id"
                        appendTo="body"
                        [readonly]="!canEditLocations()"
                        placeholder="Select LR"
                        [(ngModel)]="pickup.lrId"
                        (ngModelChange)="onPickupLrChange(i)">
                        </ng-select>
                    </div>
            
                    </div>
            
                    <div class="form-grid">
                    <div class="form-field full">
                        <label>Full Address <span class="required" *ngIf="canEditLocations()">*</span></label>
                        <input
                        type="text"
                        class="form-control"
                        [ngClass]="{ 'editable': canEditLocations() }"
                        [readonly]="!canEditLocations()"
                        [(ngModel)]="pickup.address"
                        placeholder="Full Address" />
                    </div>
                    </div>
            
                </div>
                </div>
                
                <div class="w-100">
            
                <!-- Drop -->
                <div class="sub-section-header">
                    <span>📍</span>
                    <span>Drop Locations</span>
                </div>
            
                <div class="repeatable-block" *ngFor="let drop of dropRows; let j = index">
                    <div class="repeatable-header" *ngIf="dropRows.length > 1 || canEditLocations()">
                    <span class="repeatable-title">Drop {{ j + 1 }}</span>
                    <span
                        class="lhc-section-icon cursor-pointer"
                        *ngIf="canEditLocations() && dropRows.length > 1"
                        (click)="removeLocationRow(j)">
                        ❌
                    </span>
                    </div>
            
                    <div class="form-grid">
            
                    <div class="form-field">
                        <label>Pincode <span class="required" *ngIf="canEditLocations()">*</span></label>
                        <input
                        type="text"
                        class="form-control"
                        [ngClass]="{ 'editable': canEditLocations() }"
                        [readonly]="!canEditLocations()"
                        [(ngModel)]="drop.pincode"
                        placeholder="Pincode" />
                    </div>
            
                    <div class="form-field">
                        <label>Location <span class="required" *ngIf="canEditLocations()">*</span></label>
                        <ng-select
                        [items]="locationList"
                        bindLabel="cityName"
                        bindValue="id"
                        appendTo="body"
                        [readonly]="!canEditLocations()"
                        placeholder="Select Location"
                        [(ngModel)]="drop.city">
                        </ng-select>
                    </div>
            
                    <div class="form-field" *ngIf="drop.city == -1">
                        <label>Custom Location Name <span class="required" *ngIf="canEditLocations()">*</span></label>
                        <input
                        type="text"
                        class="form-control"
                        [ngClass]="{ 'editable': canEditLocations() }"
                        [readonly]="!canEditLocations()"
                        [(ngModel)]="drop.otherCity"
                        placeholder="Type Location" />
                    </div>

                    <!--
                      Select LR — links this Drop to one of the LR
                      rows entered in the "LR — Lorry Receipt" section
                      above (1 LR per pickup+drop pair). UI only for
                      now; not yet sent in the save payload.
                    -->
                    <div class="form-field">
                        <label>Select LR</label>
                        <ng-select
                        [items]="lrRows"
                        bindLabel="lrNumber"
                        bindValue="id"
                        appendTo="body"
                        [readonly]="!canEditLocations()"
                        placeholder="Select LR"
                        [(ngModel)]="drop.lrId"
                        (ngModelChange)="onDropLrChange(j)">
                        </ng-select>
                    </div>
            
                    </div>
            
                    <div class="form-grid">
                    <div class="form-field full">
                        <label>Full Address <span class="required" *ngIf="canEditLocations()">*</span></label>
                        <input
                        type="text"
                        class="form-control"
                        [ngClass]="{ 'editable': canEditLocations() }"
                        [readonly]="!canEditLocations()"
                        [(ngModel)]="drop.address"
                        placeholder="Full Address" />
                    </div>
                    </div>
            
                </div>
                </div>
                </div>
            
                <div class="section-footer" *ngIf="canEditLocations()">
                <button
                    type="button"
                    class="btn btn-purple"
                    [disabled]="locationsSaving || !isLocationsValid()"
                    (click)="saveLocations()">
                    {{ locationsSaving ? 'Saving...' : 'Save' }}
                </button>
                </div>
            </div>

          <!-- ══════════════════════════════════════
                SECTION 6: Tracking
            ══════════════════════════════════════ -->
            <div class="card-section">
                <div class="section-header between">
                <div class="d-flex align-items-center gap-2">
                    <span class="step-badge">3e</span>
                    <h5>Tracking</h5>
                </div>
                <button
                    type="button"
                    *ngIf="!trackingData?.url"
                    class="btn btn-fetch"
                    [disabled]="trackingFetching || !canFetchTracking()"
                    (click)="fetchTracking()">
                    {{ trackingFetching ? 'Fetching...' : 'Fetch Tracking' }}
                </button>
                </div>
            
                <div class="section-body">
            
                <div class="tracking-banner" *ngIf="!canFetchTracking()">
                    <span class="tracking-icon">⏳</span>
                    <span>Tracking will be enabled once LHC vehicle &amp; driver details are filled.</span>
                </div>
            
                <div class="tracking-banner" *ngIf="canFetchTracking() && !trackingData">
                    <span class="tracking-icon">📡</span>
                    <span>Click "Fetch Tracking" to get the live tracking link for this trip.</span>
                </div>
            
                <div class="tracking-fetched-card" *ngIf="trackingData">
                    <div class="tracking-fetched-header">
                    <span>📍 Live Tracking</span>
                    <span class="tracking-fetched-badge" *ngIf="trackingData.id">#{{ trackingData.id }}</span>
                    </div>
                    <div class="tracking-fetched-body">
                    <a
                        *ngIf="trackingData.url"
                        [href]="trackingData.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="btn btn-purple tracking-open-btn">
                        🔗 Open Tracking
                    </a>
                    <span *ngIf="!trackingData.url" class="tracking-no-url">No tracking URL available</span>
                    </div>
                </div>
            
                </div>
            </div>

          <!-- Bottom bar -->
          <div class="bottom-bar" *ngIf="checkTripStatus('TRIP_GENERATED')">
            <button class="btn btn-primary" [disabled]="!canStartTrip" (click)="startTrip()">Start Trip</button>
            <button class="btn btn-cancel" style="padding: 4px 15px !important;min-width: 90px;" (click)="cancelTrip()">Cancel Trip</button>
          </div>

          <div class="bottom-bar" *ngIf="canPrintLrTemplate()" >
            <button type="button" class="btn btn-primary" (click)="downloadLrTemplate()">⬇️ Download LR Template</button>
          </div>
          <!-- <div class="bottom-bar d-flex gap-2" *ngIf="canPrintLrTemplate()">
            <button type="button" class="btn btn-outline-purple" *ngIf="canPrintLrTemplate()" (click)="printLrTemplate()">🖨️ Print Template</button>
            <button type="button" class="btn btn-outline-purple" *ngIf="canPrintLrTemplate()" (click)="downloadLrTemplate()">⬇️ Download Template</button>
          </div> -->
  
        </div>
      </div>
    </div>
  </div>